import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import ClientRoutes from "./Routes";
import MainUser from "../components/user/MainUser";
import Instruction from "../components/user/instruction/Instruction";
import MainTodos from "../components/user/todos/MainTodos";
import Invitation from "../components/common/invitation/Invitation";
import EditPage from "../components/common/invitation/EditPage";
import SuccessPage from "../components/common/payments/SuccessPage";
import MainTables from "../components/user/tables/MainTables";
import SelfInvitation from "../components/common/invitation/SelfInvitation";
import Invitation33 from "../components/common/invitation/Invitation33";

const UserSwitch = () => {
  return (
    <Switch>
      <Route
        exact={true}
        path={ClientRoutes.User.main}
        component={(props) => <MainUser {...props} />}
      />
      {/* <Route
        exact={true}
        path={ClientRoutes.User.tables}
        component={(props) => <MainTables {...props} />}
      /> */}
      <Route
        exact={true}
        path={ClientRoutes.User.instruction}
        component={(props) => <Instruction {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.User.todos}
        component={(props) => <MainTodos {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.User.editDetails}
        component={(props) => <EditPage {...props} />}
      />
      <Route
        exact={true}
        path={ClientRoutes.UnAuth.payment}
        component={(props) => <SuccessPage {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.invitation}
        component={(props) => <Invitation {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.invitation33}
        component={(props) => <Invitation33 {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.selfInvitation}
        component={(props) => <SelfInvitation {...props} />}
      />
      <Redirect from="/" to={ClientRoutes.User.main} />
    </Switch>
  );
};

export default UserSwitch;
